import React from 'react';
import Header from '../components/Header';

function DoneRecipes() {
  return (
    <div>
      <Header titlePage="Receitas Feitas" />
    </div>
  );
}

export default DoneRecipes;
